import type { KpMap } from 'src/models';
import type { GIKp } from 'src/models/geoItem';
import type { KilopostsMaster } from 'src/models/apis/master/masterResponse';
import type { Kilopost } from 'src/models/movie';

// KP配列を路線名#方向ごとに仕分ける.
// さらにその中で本線とそれ以外(場所ごと)に仕分けて、KP順に並べる.
export function convKiloposts(obfuscatedKpObj: KilopostsMaster): {
  kpMapByRoadnameDirectionPlace: KpMap;
  kpMapByKpUid: Map<string, GIKp>;
} {
  const kps = deobfuscateKps(obfuscatedKpObj);
  // 路線名、方向、場所(本線 or 場所名) でまとめたもの.
  const ret1: KpMap = new Map();
  // kpUidをキーにしたもの.
  const ret2: Map<string, GIKp> = new Map();

  for (const kp of kps) {
    // 路線名、方向、場所(本線 or 場所名) でまとめる.
    const k1 = `${kp.roadName}#${kp.direction}`;
    const k2 = kp.placeName;
    if (!ret1.has(k1)) { ret1.set(k1, new Map()); }
    const obj1 = ret1.get(k1);
    // 絶対あるので、TSエラー回避のため
    if (!obj1) { throw new Error('obj1 is null'); }
    if (!obj1.has(k2)) { obj1.set(k2, []); }
    const arr = obj1.get(k2);
    // 絶対あるので、TSエラー回避のため
    if (!arr) { throw new Error('arr is null'); }
    const giKp: GIKp = {
      ...kp,
      kp: parseFloat(kp.kp),
      kp2: kp.kp2 ? parseInt(kp.kp2.toString()) : kp.kp2,
      kpCalc: parseFloat(kp.kpCalc),
      location: { lat: parseFloat(kp.location.lat), lon: parseFloat(kp.location.lon) },
      placeNameDisp: kp.placeName === 'main_line' ? '' : kp.placeName,
    };

    arr.push(giKp);

    // kpUidでまとめる.
    ret2.set(kp.kpUid, giKp);
  }

  for (const ent1 of ret1) {
    const obj1 = ent1[1];
    for (const ent2 of obj1) {
      ent2[1].sort((a, b) => {
        const v1 = a.kpCalc;
        const v2 = b.kpCalc;
        return v1 < v2 ? -1 : (v1 > v2 ? 1 : 0);
      });
    }
  }
  return { kpMapByRoadnameDirectionPlace: ret1, kpMapByKpUid: ret2 };
}

export function deobfuscateKps(origKpObj: KilopostsMaster): Kilopost[] {
  // サーバ側で短縮されているものを元に戻す.
  // property名、あとroadNameとroadNameDisp.
  const kps = origKpObj.kiloposts;
  const kpValMap = origKpObj.kilopost_val_map;

  const results: Kilopost[] = [];
  kps.forEach(kp => {
    results.push({
      kpUid: kp.a,
      roadNameDisp: kpValMap['b'] ? kpValMap['b'][kp.b] : '',
      roadName: kpValMap['c'] ? kpValMap['c'][kp.c] : '',
      direction: kpValMap['d'] ? kpValMap['d'][kp.d] : kp.d,
      roadSectionType: kpValMap['e'] ? kpValMap['e'][kp.e] : kp.e,
      placeName: kpValMap['f'] ? kpValMap['f'][kp.f] : kp.f,
      kpPrefix: kpValMap['g'] ? kpValMap['g'][kp.g] : kp.g,
      kp: kpValMap['h'] ? kpValMap['h'][kp.h] : kp.h,
      kp2: kpValMap['i'] ? kpValMap['i'][kp.i] : kp.i,
      kpCalc: kpValMap['j'] ? kpValMap['j'][kp.j] : kp.j,
      location: {
        lat: kpValMap['k'] ? kpValMap['k'][kp.k] : kp.k,
        lon: kpValMap['l'] ? kpValMap['l'][kp.l] : kp.l,
      },
      kpSetId: kpValMap['m'] ? kpValMap['m'][kp.m] : kp.m,
      bikou1: kpValMap['n'] && kp.n ? kpValMap['n'][kp.n] : kp.n,
      kpDisp: kpValMap['o'] && kp.o ? kpValMap['o'][kp.o] : kp.o,
      angle: kpValMap['p'] ? kpValMap['p'][kp.p] : kp.p,
    });
  });

  return results;
}

export function isKpIncreaseDirection(roadName: string, direction: string): boolean {
  const kpIncDirectionset = new Set(['下', '南', '西', '外']);
  // 大黒は大黒JCTから生麦JCTに向かってKPが増えるが、
  // 何故か生麦に向かう方が上りとなっている
  const directionFlipRoadNameSet = new Set(['高速神奈川5号大黒線']);

  let result = kpIncDirectionset.has(direction);
  if (directionFlipRoadNameSet.has(roadName)) {
    result = !result;
  }
  return result;
}
